import { render, staticRenderFns } from "./AFormularioPDF.vue?vue&type=template&id=5fc90e8a"
import script from "./AFormularioPDF.vue?vue&type=script&lang=js"
export * from "./AFormularioPDF.vue?vue&type=script&lang=js"
import style0 from "./AFormularioPDF.vue?vue&type=style&index=0&id=5fc90e8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports